import React, { useEffect, useState } from "react";
import { Box, Button, Chip } from "@mui/material";
import styles from "./styles.module.css";
import { EmojiEventsOutlined } from "@mui/icons-material";
import supabase from "../../../../../../supabase/client";
import { useParams } from "react-router-dom";
import Info from "../../../../../../components/info";
import { defaultSkillImage } from "../../../../../../constants";
import { useTheme } from "../../../../../../context/themeContext";
import useInfoBoxs from "../../../../../../hooks/useInfoBoxs";
import { useSelector } from "react-redux";
import axios from "axios";
import { node_server } from "../../../../../../constants";

function SkillCoverImage({ skill }) {
  const [updatedSkill, setUpdatedSkill] = useState({ ...skill });
  const infoBoxes = useInfoBoxs();
  const { theme } = useTheme();
  const { id } = useParams();
  const [nomination, setNomination] = useState([]);
  const user = useSelector((state) => state.user.value);
  const coverImage = updatedSkill?.skill_cover_image
    ? updatedSkill?.skill_cover_image
    : defaultSkillImage;

  const handleNominate = async () => {
    if (nomination.length > 0) return;
    if (id === user?.id) return;

    const { error } = await axios.post(
      `${node_server}/api/skills/nominations`,
      {
        skillId: skill?.id,
      },
      { withCredentials: true },
    );

    if (error) console.log(error);
    if (!error) setNomination([{ skill_id: skill?.id, nominator_id: user.id }]);
  };

  useEffect(() => {
    setUpdatedSkill({ ...skill });
  }, [skill]);

  useEffect(() => {
    updatedSkill.is_nominated = nomination.length > 0;
  }, [nomination]);

  useEffect(() => {
    const fetchNominations = async () => {
      const { data, error } = await axios.get(
        `${node_server}/api/skills/nominations`,
        {
          skillId: updatedSkill?.id,
        },
        { withCredentials: true },
      );
      if (error) console.log(error);
      if (data) setNomination(data);
    };

    if (!updatedSkill?.id) return;
    fetchNominations();
  }, [id, user, updatedSkill]);

  return (
    <Box className={styles.skillsImg}>
      <Box className={styles.tags}>
        {updatedSkill?.is_editor_choice && (
          <Chip
            label={"Creators' Choice"}
            variant="contained"
            icon={<EmojiEventsOutlined />}
            sx={{
              textTransform: "uppercase",
              padding: "6px 16px 6px 3px",
              gap: "14px",
              bgcolor: theme.palette.primary.main,
              color: "#FFF",
              "& svg": {
                color: "inherit !important",
              },
            }}
          />
        )}
        {!updatedSkill?.is_editor_choice && (
          <Box className={styles.nominate}>
            <Button
              variant="contained"
              onClick={handleNominate}
              sx={{
                textTransform: "capitalize",
                bgcolor:
                  nomination.length > 0
                    ? theme.palette.darkgrey.darkgrey300
                    : theme.palette.secondary.dark,
                color: "#FFF",
                height: "32px",
                fontSize: "16px",
                fontWeight: "600",
                padding: "0px 12px",
              }}
            >
              {nomination.length > 0 ? "Nominated" : "Nominate"}
            </Button>
            {infoBoxes.map((item, index) => {
              if (item.name === "nominate") {
                return (
                  <Info
                    heading={item.title}
                    content={item.content}
                    key={index}
                  />
                );
              }
            })}
          </Box>
        )}
        {updatedSkill?.accept_only_paid_project && (
          <>
            <Chip
              label="Pro"
              sx={{
                bgcolor: theme.palette.tertiary.golden500,
                color: "# FFF",
              }}
            />
            {infoBoxes.map((item, index) => {
              if (item.name === "pro") {
                return (
                  <Info
                    heading={item.title}
                    content={item.content}
                    key={index}
                  />
                );
              }
            })}
          </>
        )}
      </Box>
      <Box
        className={styles.primaryImg}
        sx={{
          backgroundImage: `url(${coverImage})`,
        }}
      >
        <Box className={styles.options}>
          {updatedSkill?.is_primary && (
            <Chip
              label="Primary Skill"
              sx={{
                bgcolor: theme.palette.warning.main,
                color: "#FFF",
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default SkillCoverImage;
